import { Star } from "lucide-react";

export default function Stars({ count = 5, className = "" }) {
  return (
    <div className={`flex items-center gap-1 ${className}`} aria-label={`${count} stars`}>
      {Array.from({ length: count }).map((_, i) => (
        <Star key={i} className="w-4 h-4 fill-[#F28C00] text-[#F28C00]" />
      ))}
    </div>
  );
}
